// extracted by mini-css-extract-plugin
module.exports = {"navLogo":"nav-logo_navLogo__4J5R2","minimal":"nav-logo_minimal__6rz4B","icon":"nav-logo_icon__l7S5h","atlas":"nav-logo_atlas__rUCjT"};